import React, { Component } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import plusIcon from '../../assets/img/plus.svg';

export default class SelectSingleTag extends Component {
  static propTypes = {
    value: PropTypes.object,
    options: PropTypes.array,
    placeholder: PropTypes.string,
    onRemove: PropTypes.func,
    onChange: PropTypes.func,
    onRemote: PropTypes.func,
    getOptionValue: PropTypes.func,
    getOptionLabel: PropTypes.func,
    style: PropTypes.object
  }

  constructor(props) {
    super(props);
  }

  colourStyles = {
    control: (styles, state) => ({ ...styles, borderLeft: 0, borderRight: 0, borderRadius: 0,
      borderTop: state.isFocused ? 0 : 0,
      boxShadow: state.isFocused ? 0 : 0,
      '&:hover': {
        borderTop: state.isFocused ? 0 : 0
      }
    }),
    container: () => (this.props.style)
  };
  render() {
    return (
      !this.props.value
        ? (
          <React.Fragment>
            <img src={plusIcon} style={{width: 24, marginRight: 10}}/>
            <Select
              isClearable
              label='Single select'
              styles={this.colourStyles}

              value={this.props.value}
              options={this.props.options}
              onChange={this.props.onChange}
              placeholder={this.props.placeholder}
              components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null}}
              onMenuOpen={() => this.props.onRemote && this.props.onRemote()}
              getOptionValue={this.props.getOptionValue}
              getOptionLabel={this.props.getOptionLabel}
            />
          </React.Fragment>
        )
        : (
          // <div style={{display: 'inline-block'}}>
          <div style={{position: 'relative', padding: '2px 25px 2px 10px', border: '1px solid #888888', borderRadius: '3px', color: '#888', backgroundColor: '#ddd'}}>
            {this.props.getOptionLabel(this.props.value)}
            <span style={{cursor: 'pointer', fontWeight: 'bold', position: 'absolute', right: 7, top: 1, color: 'black'}} onClick={this.props.onRemove}>x</span>
          </div>
          // </div>
        )
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SingleSelect/index.js